import { render, staticRenderFns } from "./syspasswordconfig.vue?vue&type=template&id=550cbea8"
import script from "./syspasswordconfig.vue?vue&type=script&lang=js"
export * from "./syspasswordconfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports